export default __webpack_public_path__ + "static/media/okyc-verified.f3f73b07.png";